"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANCHOR_RULES = void 0;
const _abstract_1 = require("../_abstract");
/**
 * Set of rules (constraints) associated with the `AnchorToken`.
 */
exports.ANCHOR_RULES = _abstract_1.generateRules({
    pl: [
        'Musi zaczynać się od znaku [@]'
    ]
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5jaG9yLnJ1bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3Rva2VuaXplcnMvYW5jaG9yL2FuY2hvci5ydWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsK0JBQStCOzs7QUFFL0IsNENBQTREO0FBRTVEOztHQUVHO0FBQ1UsUUFBQSxZQUFZLEdBQW1CLHlCQUFhLENBQUM7SUFDeEQsRUFBRSxFQUFFO1FBQ0YsZ0NBQWdDO0tBQ2pDO0NBQ0YsQ0FBQyxDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQ29weXJpZ2h0IMKpIDIwMjEgTW92ZSBDbG9zZXJcblxuaW1wb3J0IHsgZ2VuZXJhdGVSdWxlcywgVG9rZW5pemVyUnVsZXMgfSBmcm9tICcuLi9fYWJzdHJhY3QnXG5cbi8qKlxuICogU2V0IG9mIHJ1bGVzIChjb25zdHJhaW50cykgYXNzb2NpYXRlZCB3aXRoIHRoZSBgQW5jaG9yVG9rZW5gLlxuICovXG5leHBvcnQgY29uc3QgQU5DSE9SX1JVTEVTOiBUb2tlbml6ZXJSdWxlcyA9IGdlbmVyYXRlUnVsZXMoe1xuICBwbDogW1xuICAgICdNdXNpIHphY3p5bmHEhyBzacSZIG9kIHpuYWt1IFtAXSdcbiAgXVxufSlcbiJdfQ==